import {createContext} from 'react';
function noop(){}
export const SelectionCriteriaContext = createContext({
    addItem: noop,
    addGroup: noop,
    remove: noop,
    changeOperator: noop,
    withoutGroups: false,
})